import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import ResourcesLeft from '../Resources/Resources_Left'

function Main() {


    const Classrooms = [
        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/Classroom1.jpg" },

        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/Classroom2.jpg" },

        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/Classroom3.jpg" },

        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/Classroom4.jpg" },

        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/Classroom10.jpg" },

        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/Classroom12.jpg" },

        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/Classroom13.jpg" }
    ]


    const Library = [

        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/Library2.jpg" }
     
    ]
    const Hostels = [
        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/hostel1.jpg" },
        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/hostel6.jpg" },
        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/hostel10.jpg" },
    ]

    const Batminton = [
        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/Batminton%20Court1.jpg" },
        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/Batminton%20Court3.jpg" }
    ]

    const Basket = [
        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/Vollyball%20court.jpg" }
    ]


    const Dining = [
        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/Dining%20Hall%20.jpg" }
    ]

    const Gym = [
        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/gym1.jpg" },
        { img: "https://files.iittp.ac.in/pics/transitcampus/infra/gym2.jpg" }        
    ]

    const Creche = [
        { img: "https://files.iittp.ac.in/pics/creche/1.jpg" },
        { img: "https://files.iittp.ac.in/pics/creche/2.jpg" },
        { img: "https://files.iittp.ac.in/pics/creche/3.jpg" },
        { img: "https://files.iittp.ac.in/pics/creche/4.jpg" },
        { img: "https://files.iittp.ac.in/pics/creche/5.jpg" },
    ]



    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Inter-IIT-Sports-Meet" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>
                   

                            <Col md={12} className='c-right c-lineheight2dot5 text-dark'>

                            
                                <h3 className='c-headline mb-3'>Classrooms</h3>                          
                                <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                    {Classrooms.map((item, Index) => (
                                        <div className="grid-item financial col-3 mt-3" key={Index}>                        
                                                <figure className="gallery-image">
                                                    <img src={item.img} alt="img" className="img" />
                                                </figure>
                                        </div>
                                    ))}
                                </div>


                                <h3 className='c-headline mt-5 mb-3'>Library</h3>                      
                                <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                    {Library.map((item, Index) => (
                                        <div className="grid-item financial col-3 mt-3" key={Index}>
                                            <figure className="gallery-image">
                                                <img src={item.img} alt="img" className="img" />
                                            </figure>
                                        </div>
                                    ))}
                                </div>


                                <h3 className='c-headline mt-5 mb-3'>Hostels</h3>
                                <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                    {Hostels.map((item, Index) => (
                                        <div className="grid-item financial col-3 mt-3" key={Index}>
                                            <figure className="gallery-image">
                                                <img src={item.img} alt="img" className="img" />
                                            </figure>
                                        </div>
                                    ))}
                                </div>

                                <h3 className='c-headline mt-5 mb-3'>Batminton </h3>
                                <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                    {Batminton.map((item, Index) => (
                                        <div className="grid-item financial col-3 mt-3" key={Index}>
                                            <figure className="gallery-image">
                                                <img src={item.img} alt="img" className="img" />
                                            </figure>
                                        </div>
                                    ))}
                                </div>


                                <h3 className='c-headline mt-5 mb-3'>Basket  </h3>
                                <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                    {Basket.map((item, Index) => (
                                        <div className="grid-item financial col-3 mt-3" key={Index}>
                                            <figure className="gallery-image">
                                                <img src={item.img} alt="img" className="img" />
                                            </figure>
                                        </div>
                                    ))}
                                </div>




                                <h3 className='c-headline mt-5 mb-3'>Dining  </h3>
                                <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                    {Dining.map((item, Index) => (
                                        <div className="grid-item financial col-3 mt-3" key={Index}>
                                            <figure className="gallery-image">
                                                <img src={item.img} alt="img" className="img" />
                                            </figure>
                                        </div>
                                    ))}
                                </div>



                                <h3 className='c-headline mt-5 mb-3'>Gym  </h3>
                                <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                    {Gym.map((item, Index) => (
                                        <div className="grid-item financial col-3 mt-3" key={Index}>
                                            <figure className="gallery-image">
                                                <img src={item.img} alt="img" className="img" />
                                            </figure>
                                        </div>
                                    ))}
                                </div>


                                <h3 className='c-headline mt-5 mb-3'>Creche   </h3>
                                <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                    {Creche.map((item, Index) => (
                                        <div className="grid-item financial col-3 mt-3" key={Index}>
                                            <figure className="gallery-image">
                                                <img src={item.img} alt="img" className="img" />
                                            </figure>
                                        </div>
                                    ))}
                                </div>




                            </Col>
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;